import { Component, OnInit } from '@angular/core';
import {CdkDragDrop, moveItemInArray, transferArrayItem} from '@angular/cdk/drag-drop';
import { ActivatedRoute, Router } from '@angular/router';
import { ServicioFirebaseService } from 'src/app/servicios/servicio-firebase.service';
import { Observable } from 'rxjs';
import { Datossecuencia } from 'src/app/modelos/datos/datossecuencia.model';
///variable de jquey para modal//
declare var $: any;
@Component({
  selector: 'app-realizadorsecuencia',
  templateUrl: './realizadorsecuencia.component.html',
  styleUrls: ['./realizadorsecuencia.component.css']
})
export class RealizadorsecuenciaComponent implements OnInit {
  public titulo: string;
  public nombrerealizador: string = "";
  public accederActividad: boolean;
  public minutos: number = 0;
  public uid:string="";
  segundos: number = 0;
  interval;
  public claveActividad: string;
  public datosActividad: Observable<Datossecuencia>;
  public descripcion:string;
  public descripcionsecuencia:string;
  public pasosOrdenCorrecto:Array<string>=[];
  public calificacion:number=0;
  pasosDesordenados = [
  ];
  pasosOrdenados = [
    
  ];
 
  constructor(public route: ActivatedRoute, public router: Router, private serivicio: ServicioFirebaseService) {
    
   }
  ngOnInit() {
    this.route.params.forEach(params => {
      let clave = params["clave"];
      this.claveActividad = this.claveActividad;
      this.datosActividad = this.serivicio.tomarInformacionActividadSecuencia(clave);
      this.datosActividad.subscribe(res => {
        this.uid=res.uid;
        this.descripcion = res.descripcion;
        this.descripcionsecuencia = res.descripcionsecuencia;
        res.pasos.forEach((p)=>{
          this.pasosOrdenCorrecto.push(p);
        });
        this.pasosDesordenados = res.pasos;
        this.pasosDesordenados.sort();
        this.titulo = res.titulo;
      });

    })
   this.mostarModal("#myModal");
  }
  empezarActividad() {
    if (this.nombrerealizador != "") {
      this.esconderModal("#myModal");
      this.iniciarTimer();
      this.accederActividad = true;
    } else {
      this.accederActividad = false;

    }
  }
  iniciarTimer() {
    this.interval = setInterval(() => {
      if (this.segundos == 59) {
        this.segundos = 0;
        this.minutos++;
      } else {
        this.segundos++;
      }
    }, 1000)
  }
  drop(event: CdkDragDrop<string[]>) {
    if (this.pasosDesordenados) {
      if (event.previousContainer === event.container) {
        moveItemInArray(event.container.data, event.previousIndex, event.currentIndex);
      } else {
        transferArrayItem(event.previousContainer.data,
                        event.container.data,
                        event.previousIndex,
                        event.currentIndex);
      }
    }
  }
  pausarTimer() {
    clearInterval(this.interval);
  }
  mostarModal(id: string): void {
    $(id).modal('show');
  }
  esconderModal(id: string) {
    $(id).modal('hide');
  }
  terminarActividad(){
    var aciertos=0;
    for (var i = 0; i < this.pasosOrdenCorrecto.length; i++) {
      if(this.pasosOrdenCorrecto[i]==this.pasosOrdenados[i]){
        aciertos++;
      }
   }
   this.pausarTimer();
   this.calificacion=aciertos/this.pasosOrdenCorrecto.length*100;
   this.mostarModal("#myModal-calificacion");
   var tiempo=this.minutos.toString()+":"+this.segundos.toString();
   this.serivicio.registrarActividadHecha(this.calificacion.toString(),this.nombrerealizador,tiempo,"secuencia",this.titulo,this.uid);
  }

}
